export enum HeaderActionOption {
  EDIT = 'edit',
  EXPORT = 'export',
  ARCHIVE = 'archive',
  UNARCHIVE = 'unarchive',
  LEAVE = 'leave',
  DELETE = 'delete',
  MUTE = 'mute',
  UNMUTE = 'unmute',
}
